export function isChar(char) {
    return (typeof char === "string" &&
        char.length === 1 &&
        char.charCodeAt(0) >= 97 &&
        char.charCodeAt(0) <= 122);
}
/**
 * Converts a string to a word. Ignores invalid characters.
 * @param str The string to be converted
 * @returns The word
 */
export function stringToWord(str) {
    const word = [];
    for (let i = 0; i < str.length; i++) {
        const letter = str[i];
        if (isChar(letter)) {
            word.push(letter);
        }
    }
    return word;
}
/**
 * Converts a word to a string.
 * @param word The word to be converted
 * @returns The string
 */
export function wordToString(word) {
    return word.join("");
}
